<span *ngIf="info" tiptool="{{ info }}" placement="{{ placement }}">
  <mat-icon style="vertical-align: top">info_outline</mat-icon>
</span>
